import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";

// Contexts
import { AuthProvider } from "./contexts/AuthContext";

// Layout
import Layout from "./components/Layout";

// Public Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Testimonials from "./pages/Testimonials";
import Book from "./pages/Book";
import NotFound from "./pages/NotFound";

// Services
import ServicePage from "./pages/services/ServicePage";
import NutritionApplication from "./pages/services/NutritionApplication";

// Resources (new routes)
import Blog from "./pages/resources/Blog";
import BlogPost from "./pages/resources/BlogPost";
import VideoLibrary from "./pages/resources/VideoLibrary";
import VideoPage from "./pages/resources/VideoPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminVideos from "./pages/admin/AdminVideos";
import AdminNutritionApps from "./pages/admin/AdminNutritionApps";

// Helper for legacy slug redirects
const LegacyRedirect = ({ base }) => {
  const { slug } = useParams();
  return <Navigate to={`${base}/${slug}`} replace />;
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes with Layout */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/testimonials" element={<Layout><Testimonials /></Layout>} />
            <Route path="/book" element={<Layout><Book /></Layout>} />
            
            {/* Services */}
            <Route path="/services/nutritional-therapy/apply" element={<Layout><NutritionApplication /></Layout>} />
            <Route path="/services/:slug" element={<Layout><ServicePage /></Layout>} />
            
            {/* Resources - Blog (new routes) */}
            <Route path="/resources/blog" element={<Layout><Blog /></Layout>} />
            <Route path="/resources/blog/:slug" element={<Layout><BlogPost /></Layout>} />
            
            {/* Resources - Videos (new routes) */}
            <Route path="/resources/videos" element={<Layout><VideoLibrary /></Layout>} />
            <Route path="/resources/videos/:slug" element={<Layout><VideoPage /></Layout>} />

            {/* Legacy routes - redirect to new structure */}
            <Route path="/blog" element={<Navigate to="/resources/blog" replace />} />
            <Route path="/blog/:slug" element={<LegacyRedirect base="/resources/blog" />} />
            <Route path="/videos" element={<Navigate to="/resources/videos" replace />} />
            <Route path="/videos/:slug" element={<LegacyRedirect base="/resources/videos" />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="videos" element={<AdminVideos />} />
              <Route path="nutrition-apps" element={<AdminNutritionApps />} />
            </Route>

            {/* 404 Page */}
            <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
